import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import uuid from 'uuid'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { AjPEventChangeAim } from 'components/sections/adventurous-journeys'
import { Table, Data } from 'components/layout/Table'
import { Button, ButtonGroup, BadgesLevels } from 'components/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'
import { PROGRESS_STATES } from '../../../../constants/enums'

export default class TasksAjEventsTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    approveModal: PropTypes.func.isRequired,
    rejectModal: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    changeAjParticipantEventGoal: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    ajEventState: PropTypes.object
  }

  static defaultProps = {
    tasks: {
      list: [],
      events: {
        list: []
      }
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      ajEventIdApprove: null,
      ajEventIdReject: null
    }
  }

  key = uuid.v1()

  handleApproveEventModal = ajEventIdApprove => {
    this.setState(
      {
        ajEventIdApprove
      },
      () => {
        this.props.modal(`modal-approve-aj-event-${this.key}`)
      }
    )
  }

  handleRejectEventModal = ajEventIdReject => {
    this.setState(
      {
        ajEventIdReject
      },
      () => {
        this.props.modal(`modal-reject-aj-event-${this.key}`)
      }
    )
  }

  render() {
    const { approveModal, rejectModal, data, codeLists, isAssessorManagementEnabled, ajEventState } = this.props

    const showReasons = get(ajEventState, 'value') === PROGRESS_STATES.activityApproval.id

    return (
      <div>
        <Table ths={tasksLayout.ajEventsApproval}>
          <Data>
            <tr>
              <td>
                <Link to={`${config.publicPath}/adventurous-journeys/${get(data, 'id')}/detail`}>
                  {get(data, 'id')}
                </Link>
              </td>
              <td>{get(data, 'ajEventCategory.translationText')}</td>
              <td>
                <BadgesLevels
                  levels={[{ awardLevel: get(data, 'awardLevel') }]}
                  single
                />
              </td>
              <td>{get(data, 'activityCategory.translatedName')}</td>
              <td>{get(data, 'activityCategory.parent.translatedName')}</td>
              <td>
                {get(data, 'startDate') && (
                  <FormattedDate value={data.startDate} />
                )}
              </td>
              <td>
                {get(data, 'endDate') && <FormattedDate value={data.endDate} />}
              </td>
              <td>
                {get(data, 'createdByPerson.firstName')}{' '}
                {get(data, 'createdByPerson.lastName')}
              </td>
              <td>
                {get(data, 'assessorName') || get(data, 'assessorEmail') && get(data, 'assessorPhone') || '-'}
                <br />
                {get(data, 'assessorEmail') && <small>{get(data, 'assessorEmail')}</small> ||
                get(data, 'assessorPhone') && <small>{get(data, 'assessorPhone')}</small>}
              </td>
              <td>
                <ButtonGroup>
                  <Button
                    type="button"
                    tiny
                    onClick={() =>
                      this.handleApproveEventModal(get(data, 'id'))
                    }
                    intlKey={isAssessorManagementEnabled ? 'button.authorize' : 'button.approve'}
                  >
                    {isAssessorManagementEnabled ? 'Authorize' : 'Approve'}
                  </Button>
                  <Button
                    type="button"
                    tiny
                    onClick={() => this.handleRejectEventModal(get(data, 'id'))}
                    intlKey="button.revise"
                    secondary
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <AjPEventChangeAim
          data={data}
          modal={this.props.modal}
          changeAjParticipantEventGoal={this.props.changeAjParticipantEventGoal}
        />
        <Modal id={`modal-approve-aj-event-${this.key}`} customActions>
          <TaskApprove
            id={this.state.ajEventIdApprove}
            approve={approveModal}
            modal={this.props.modal}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            activityState={PROGRESS_STATES.activityApproval.id}
            title="Approve event"
            intlKey="tasks.approve_event"
          />
        </Modal>
        <Modal id={`modal-reject-aj-event-${this.key}`} customActions enableOverflow>
          <TaskReturn
            id={this.state.ajEventIdReject}
            returnTask={rejectModal}
            modal={this.props.modal}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            showReasons={showReasons}
            codeLists={codeLists}
          />
        </Modal>
      </div>
    )
  }
}
